/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import mixpanelTrack from "app/common/MixpanelComponent";
import PromotionsLegendDropdownButton from "./legend-dropdown/PromotionsLegendDropdownButton";
import { exploreByCategories } from "./utils";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 10px 20px 90px",
  },
  label: {
    marginRight: theme.spacing(3),
    cursor: "pointer",
    fontSize: 15,
    verticalAlign: "middle",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    fontWeight: 400,
    color: theme.palette.text.secondary,
    "&[aria-pressed='true']": {
      fontWeight: 700,
      color: theme.palette.text.primary,
    },
  },
  circle: {
    display: "inline-block",
    width: 18,
    height: 18,
    borderRadius: "50%",
    marginRight: 8,
    border: "2px solid transparent",
    verticalAlign: "middle",
    transition: "border 0.2s",
  },
  circleSelected: {
    border: `2px solid ${theme.palette.text.primary}`,
  },
  exploreByContainer: {
    width: "100%",
    padding: "10px 10px",
    "&:hover": { background: "#f4f4f4" },
  },
  dropdownContainer: { width: "400px" },
  categoriesContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
}));

const PromotionsLegend = ({
  legendExploreBy,
  setLegendExploreBy,
  categories,
  // selected,
  promotionsLegendFilters,
  setPromotionsLegendFilters,
}) => {
  const classes = useStyles();

  const onClick = (e, object) => {
    if (promotionsLegendFilters.label === object.label) {
      setPromotionsLegendFilters({});
    } else setPromotionsLegendFilters(object);
  };

  return (
    <div className={classes.root}>
      <div className={classes.dropdownContainer}>
        <PromotionsLegendDropdownButton selectedScenarioLabel={legendExploreBy}>
          {/* eslint-disable-next-line no-unused-vars */}
          {exploreByCategories.map(({ label, value }) => (
            <div
              className={classes.exploreByContainer}
              style={{
                background: `${
                  legendExploreBy === value ? "#e4e4e4" : "transparent"
                }`,
              }}
            >
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  width: "100%",
                }}
                type="button"
                onClick={() => {
                  setLegendExploreBy(value);
                  /* MIXPANEL TRACKS */
                  mixpanelTrack("Value destroyers explore by selected");
                  /* END OF MIXPANEL TRACKS */
                }}
              >
                <span
                  style={{
                    color: "#4e4e4e",
                    fontSize: "15px",
                    // fontWeight: `${legendExploreBy === label ? "700" : "500"}`,
                  }}
                >
                  {value}
                </span>
              </button>
            </div>
          ))}
        </PromotionsLegendDropdownButton>
      </div>
      <div className={classes.categoriesContainer}>
        {Array.from(
          Object.values(categories[legendExploreBy] || categories.promotions)
        ).map(({ id, label, background, borderColor }) => (
          <span
            key={label}
            className={classes.label}
            style={
              promotionsLegendFilters.label === label
                ? { fontWeight: 700, color: "#000" }
                : { fontWeight: 500, color: "#4e4e4e" }
            }
            onClick={(e) => onClick(e, { legendExploreBy, id, label })}
            tabIndex={0}
            role="button"
            aria-pressed={promotionsLegendFilters.label === label}
          >
            <span
              className={
                promotionsLegendFilters.label === label
                  ? `${classes.circle} ${classes.circleSelected}`
                  : classes.circle
              }
              style={{ background, borderColor }}
            />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PromotionsLegend;
